import { GetResourceTask } from '@/Core/Tasks/Resources/GetResourceTask'
import { ResourceCorrespondenceConfig } from '@/Ship/Configs/ResourceCorrespondenceConfig'

/**
 * Resolve a frontend resource key from a backend resource code.
 *
 * `ResourceCorrespondenceConfig` may store either a single string, an array of
 * strings (multiple frontend resources mapped to one backend code — first one wins),
 * or the literal `'?'` to mark unmapped resources. Returns `null` for unmapped/missing.
 */
export const getFrontendResourceKey = (backendResource: string): string | null => {
    const frontendKey =
        ResourceCorrespondenceConfig[backendResource as keyof typeof ResourceCorrespondenceConfig]

    if (Array.isArray(frontendKey)) return frontendKey[0] ?? null
    if (frontendKey === '?') return null
    return frontendKey || null
}

/**
 * Human-readable display name for a backend resource code.
 * Falls back to the backend code itself when no frontend mapping or no resource title is found.
 */
export const getResourceDisplayName = (backendResource: string): string => {
    const frontendKey =
        ResourceCorrespondenceConfig[backendResource as keyof typeof ResourceCorrespondenceConfig]

    if (!frontendKey || frontendKey === '?') return backendResource

    const resourceKey = Array.isArray(frontendKey) ? frontendKey[0] : frontendKey
    if (!resourceKey) return backendResource

    const resourceConfig = GetResourceTask(resourceKey)
    return resourceConfig?.title || backendResource
}
